// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-fca585f8] .reports-dropdown .btn {\n  color: #2DB782;\n  font-weight: normal;\n  font-size: 1rem;\n  margin-right: 0.5rem;\n  padding: 3px 10px;\n}", ""]);
// Exports
module.exports = exports;
